import { render, staticRenderFns } from "./NotifyUsersModal.vue?vue&type=template&id=5b7854fa&"
import script from "./NotifyUsersModal.vue?vue&type=script&lang=js&"
export * from "./NotifyUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports